/** MUI */
import {
    Box,
    Container,
    Grid2 as Grid,
    Typography,
} from "@mui/material";

/** Components */
import BaseButton from "../ui/BaseButton";
import classes from "./pricing.module.css";
import PlanCard from "./PlanCard";

const Pricing = (props) => {
    const { type, scrollToSection } = props;

    const goToApp = () => {
        if (type === "xero") {
            // Go contact
            scrollToSection();
        } else {
            window.open("https://go.noddok.com/?try-noddok=true&language=en", "_blank");
        }
    };

    return (
        <Box className={classes.pricing}>
            <Container maxWidth="xl" disableGutters className={classes.containerPri}>
                <Typography variant="h1" color="secondary" textAlign="center" className={classes.titleText}>
                    Flexible pricing to unlock accounting superpowers
                </Typography>
                <Grid container spacing={{ xs: 2, xl: 3 }}>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <Typography variant="body1" fontWeight={700} className={classes.paddingT}>
                            All plans include
                        </Typography>
                        <ul className={classes.list}>
                            <li>
                                <Typography variant="body3">QBO and Xero integration</Typography>
                            </li>
                            <li>
                                <Typography variant="body3">Unlimited users</Typography>
                            </li>
                            <li>
                                <Typography variant="body3">Unlimited storage</Typography>
                            </li>
                        </ul>
                        <Box className={classes.hideMobile}>
                            <Typography variant="body1" fontWeight={700} className={classes.paddingM}>
                                Pages/month
                            </Typography>
                            <Typography variant="body1" fontWeight={700} className={classes.paddingT}>
                                Processing pricing
                            </Typography>
                            <Typography variant="body3" component="div" className={classes.paddingL} gutterBottom >
                                Checks
                            </Typography>
                            <Typography variant="body3" component="div" className={classes.paddingL} gutterBottom>
                                Invoices and statements
                            </Typography>
                            <Typography variant="body3" component="div" className={classes.paddingL}>Transactions</Typography>
                            <Typography variant="body1" fontWeight={700} className={classes.paddingT}>
                                Customer support
                            </Typography>
                            <Typography variant="body3" component="div" className={classes.paddingL} gutterBottom>
                                Onboarding
                            </Typography>
                            <Typography variant="body3" component="div" className={classes.paddingL} gutterBottom>
                                Channels
                            </Typography>
                            <Typography variant="body3" component="div" className={classes.paddingL}>People</Typography>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }} className={classes.pricingContent}>
                        <PlanCard planType={1} />
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }} className={classes.pricingContent}>
                        <PlanCard planType={2} />
                    </Grid>
                    <Grid size={{ xs: 12, md: 3 }} className={classes.pricingContent}>
                        <PlanCard planType={3} />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}></Grid>
                    <Grid size={{ xs: 12, md: 3 }} sx={{ textAlign: "center" }}>
                        <BaseButton
                            onClick={goToApp}
                            variantType="secondaryContainedButton"
                            sizebutton="l"
                            disableElevation
                        >
                            {type === "xero" ? "See Nodok in action" : "Start free trial"}
                        </BaseButton>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Pricing;